import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import * as Config from '../../../configuration/consts';


@withRouter
export class Item extends React.Component<any, any> {
    constructor(props) {
        super(props);
        
        this.onEditUser = this.onEditUser.bind(this);
    }

    onEditUser(){
        this.props.editUser(this.props.email);
    }

    render() {
        const { location, children, firstName, lastName, email, forumAttachmentId,lastAccessedDate, avatar,type, ...props } = this.props;
        
        let avatarImg = forumAttachmentId ? 
                        `/api/attachment/${forumAttachmentId}?${Math.random()}` : 
                        require("../../../assets/img/Unconfirmed.png");

        let formattedEmail = type == Config.ROLE_ADMIN ? <strong>{email}</strong> : email;
        let formattedName = type == Config.ROLE_ADMIN ? <strong>{firstName} {lastName} (ADMIN)</strong> : `${firstName} ${lastName}`;
        let formattedlastAccessed = type == Config.ROLE_ADMIN ? <strong><Moment fromNow>{lastAccessedDate}</Moment></strong> : lastAccessedDate ? <Moment fromNow>{lastAccessedDate}</Moment> : undefined;
        
        return (
            <div className="row pt-2 pb-2" >
                <div className="col col-3 col-lg-1">
                        <div className="circle-avatar">
                            <img src={avatarImg} />
                        </div>
                </div>
                <div className="col col-12 col-lg-4">
                    {formattedEmail}
                </div>
                <div className="col col-12 col-lg-4">
                    {formattedName}
                </div>
                <div className="col col-6 col-lg-2">
                    <small>{formattedlastAccessed}</small>
                </div>
                <div className="col col-6 col-lg-1">
                    <div className="text-right mr-2">
                        <a onClick={this.onEditUser}>
                            <span className="fa fa-edit fa-lg"></span>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Member/Item.tsx